import React, { memo } from 'react'
import { Control } from 'react-hook-form'
import { ControlledCheckbox } from 'transfix-form/components/ControlledCheckbox'
import { Typography } from 'transfix-ui/core'
import { TUpdateMarketplaceDataFormSchema } from './UpdateMarketplaceDataFormSchema'

interface IMarketplaceDataUpdateFormBodyProps {
  control: Control<TUpdateMarketplaceDataFormSchema>
  showPhysicalAddressNote: Boolean
}

export const MarketplaceDataUpdateFormBody = memo<IMarketplaceDataUpdateFormBodyProps>(
  ({ control, showPhysicalAddressNote }) => {
    return (
      <>
        <Typography variant='body2'>Select the data fields to update.</Typography>

        <ControlledCheckbox
          name='shouldSyncLegalName'
          control={control}
          CheckboxProps={{ label: 'Carrier Name' }}
        />

        <ControlledCheckbox
          name='shouldSyncMcNumber'
          control={control}
          CheckboxProps={{ label: 'MC' }}
        />

        <ControlledCheckbox
          name='shouldSyncDbaName'
          control={control}
          CheckboxProps={{ label: 'DBA' }}
        />

        <ControlledCheckbox
          name='shouldSyncEin'
          control={control}
          CheckboxProps={{ label: 'EIN' }}
        />

        <ControlledCheckbox
          name='shouldSyncPhysicalAddress'
          control={control}
          CheckboxProps={{ label: 'Physical Address' }}
        />
        {showPhysicalAddressNote && (
          <Typography variant='body1'>
            You are required to notify the accounting team of any address changes.
          </Typography>
        )}

        <ControlledCheckbox
          name='shouldSyncContactName'
          control={control}
          CheckboxProps={{ label: 'Carrier Contact Name' }}
        />

        <ControlledCheckbox
          name='shouldSyncContactEmail'
          control={control}
          CheckboxProps={{ label: 'Carrier Contact Email' }}
        />

        <ControlledCheckbox
          name='shouldSyncContactPhone'
          control={control}
          CheckboxProps={{ label: 'Carrier Contact Phone' }}
        />
      </>
    )
  }
)
